import { react2angular } from 'react2angular';
import Loader from '__core/client/component/global/Loader.jsx';
import Contacts from '__core/client/page/Contacts.jsx';
import Jobs from '__core/client/page/Jobs.jsx';
import Tickets from '__core/client/page/Tickets.jsx';
import Modal from '__core/client/component/global/Modal.jsx';

export default angular
  .module('st.Core.React', [])
  .component('reactLoader', react2angular(Loader))
  .component('reactContacts', react2angular(Contacts))
  .component('reactJobs', react2angular(Jobs))
  .component('reactTickets', react2angular(Tickets))
  .component('reactModal', react2angular(Modal));
